<template>
  <div class="container">
    <div class="header">
      <p>{{ content.menuTitle | showChange }}</p>
      <div class="header-position">
        <span
          ><span>{{
            $t('lang.external.fzsy.content.xmtd.您当前的位置：')
          }}</span></span
        >
        <span>{{ $t('lang.external.fzsy.content.xmtd.项目首页') }} </span>
        <span>> {{ content.menuTitle | showChange }} </span>
        <span>> {{ $t('lang.external.fzsy.content.xmtd.正文') }} </span>
      </div>
    </div>
    <div class="main">
      <div class="main-text">
        <div v-html="content.body"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { formatLan } from '@/utils/lanFormat'
export default {
  name: 'describe',
  components: {},
  props: [],
  data() {
    return {}
  },
  watch: {},
  computed: {
    ...mapState({
      content: (state) => state.experiment.describeContent,
    }),
    id() {
      return this.$route.query.id
    },
    serverURL() {
      return this.publicData.serverUrl
    },
  },
  created() {},
  mounted() {},
  methods: {},
  filters: {
    showChange: function (val) {
      return formatLan(val)
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  color: #666666;
  background-color: #edf2f6;
  border-radius: 5px;
  .header {
    width: 100%;
    padding: 2vh 1.3vw;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #d7d7d7;
    p {
      color: #0c5893;
      font-weight: bold;
    }
    &-position {
      color: #999999;
      font-size: 0.83333333vw;
    }
  }
  .main {
    width: 100%;
    padding: 4.1015vh 3.125vw;
    &-text {
      img {
        width: 100%;
      }
      p {
        font-size: 0.83333333vw;
        color: #777777;
        line-height: 1.75;
        text-indent: 2rem;
      }
    }
  }
}
</style>